import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { getCookieByName, getUtmParameters } from 'src/Constants/functions'
import { initiateGoogleAuth } from 'src/Utils/googleAuth'
import { useGoogleAuthError } from 'src/Hooks/useGoogleAuthError'
import LogoIcon from 'src/Assets/Svg/logoSmall.svg?react'
import {
  ArtistContactDetailsForm,
  type FormDataProps,
} from 'src/Components/ArtistContactDetailsForm'

import { useArtistContactDetails } from './useArtistContactDetails'

export type { FormDataProps }

const Card = styled.div`
  display: flex;
  padding: 24px 40px 24px 24px;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  width: 100%;
  max-width: 960px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    border: none;
    box-shadow: none;
    padding: 0;
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`

const SidePanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  padding: 24px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

const SidePanelTitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const SidePanelText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

export const ArtistContactDetails: FC = () => {
  const { search } = useCustomSearchParams()
  const googleAuthError = useGoogleAuthError()

  const {
    isEmailExist,
    clearEmailExist,
    handleSubmit: onSubmit,
    onStartFillingForm,
    loading,
  } = useArtistContactDetails()

  const onGoogleClick = (): void => {
    const utmObj = getUtmParameters(getCookieByName('soundCampaignUtm'))
    initiateGoogleAuth({
      internalReferralCode: search?.get('referralCode') || void 0,
      referralCode: utmObj.ref || void 0,
      isSignUp: true,
    })
  }

  return (
    <Card>
      <ArtistContactDetailsForm
        onSubmit={onSubmit}
        onGoogleClick={onGoogleClick}
        isEmailExist={isEmailExist}
        clearEmailExist={clearEmailExist}
        onStartFillingForm={onStartFillingForm}
        loading={loading}
        googleAuthError={googleAuthError}
      />
      <SidePanel>
        <LogoIcon />
        <div>
          <SidePanelTitle>New Artist Profile</SidePanelTitle>
          <SidePanelText>
            Complete your contact details to launch your first campaign and
            start growing your audience.
          </SidePanelText>
        </div>
      </SidePanel>
    </Card>
  )
}
